export default "__VITE_ASSET__DI50a0pj__"